export default __webpack_public_path__ + "static/media/login.7cd450b8.png";